import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./style.css";
import { Button, Icon, InputGroup } from "@blueprintjs/core";
export default ({ demos, isOpen, setIsOpen, SideBarComponent }) => {
  const [search, setSearch] = useState("");
  const [width, setWidth] = useState(() => {
    const savedWidth = localStorage.getItem("demoNavWidth");
    return savedWidth ? parseInt(savedWidth, 10) : 300;
  });
  const [isResizing, setIsResizing] = useState(false);
  React.useEffect(() => {
    localStorage.setItem("demoNavWidth", width);
  }, [width]);
  React.useEffect(() => {
    const handleMouseMove = (e) => {
      if (isResizing) {
        const newWidth = Math.max(150, Math.min(e.clientX, 800));
        setWidth(newWidth);
      }
    };
    const handleMouseUp = () => {
      if (isResizing) {
        setIsResizing(false);
        document.body.style.userSelect = "";
        document.body.style.cursor = "";
      }
    };
    if (isResizing) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing]);
  if (!isOpen) {
    return null;
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "demo-nav-container",
      style: {
        width,
        paddingLeft: SideBarComponent ? 0 : 20,
        paddingRight: SideBarComponent ? 0 : 20,
        position: "relative",
        flexShrink: 0
        // Prevent shrinking
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: "resize-handle",
            onMouseDown: (e) => {
              e.preventDefault();
              setIsResizing(true);
              document.body.style.userSelect = "none";
              document.body.style.cursor = "col-resize";
            },
            style: {
              position: "absolute",
              top: 0,
              bottom: 0,
              right: -5,
              width: "10px",
              cursor: "col-resize",
              zIndex: 100,
              transition: "background 0.2s"
            },
            onMouseEnter: (e) => {
              e.currentTarget.style.background = "#2185d0";
            },
            onMouseLeave: (e) => {
              if (!isResizing) e.currentTarget.style.background = "transparent";
            },
            title: "Drag to resize"
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              padding: "0 10px",
              height: 50,
              minHeight: 50,
              boxSizing: "border-box",
              flexShrink: 0,
              width: "100%"
            },
            children: /* @__PURE__ */ jsx(
              Button,
              {
                style: { height: "fit-content" },
                onClick: () => {
                  setIsOpen(false);
                },
                minimal: true,
                text: "Hide Project Files",
                intent: "primary",
                icon: "chevron-left"
              }
            )
          }
        ),
        SideBarComponent ? /* @__PURE__ */ jsx(SideBarComponent, {}) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            InputGroup,
            {
              rightElement: search && /* @__PURE__ */ jsx(
                Button,
                {
                  minimal: true,
                  style: { marginRight: 10 },
                  icon: "small-cross",
                  onClick: () => {
                    setSearch("");
                  }
                }
              ),
              onChange: (e) => {
                setSearch(e.target.value);
              },
              style: {
                marginBottom: 5
                /* maxWidth: 200 */
              },
              placeholder: "Filter...",
              leftElement: /* @__PURE__ */ jsx(Icon, { style: { marginTop: 6 }, icon: "search" })
            }
          ),
          Object.keys(demos).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())).map(function(name, index) {
            if (search && !name.toLowerCase().includes(search.toLowerCase()))
              return null;
            const childLinks = demos[name].childLinks || {};
            return /* @__PURE__ */ jsxs(React.Fragment, { children: [
              /* @__PURE__ */ jsx(
                NavLink,
                {
                  exact: true,
                  to: `/${name}`,
                  activeClassName: "demo-nav-link-active",
                  className: "demo-nav-link",
                  children: name
                }
              ),
              Object.keys(childLinks).map((childKey) => {
                return /* @__PURE__ */ jsx(
                  NavLink,
                  {
                    exact: true,
                    to: `/${name}/${childKey}`,
                    activeClassName: "demo-nav-link-active",
                    className: "demo-nav-link nested",
                    children: childKey
                  },
                  childKey
                );
              })
            ] }, index);
          }),
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx("br", {}),
          "Teselagen Open Source UI Library Demo",
          /* @__PURE__ */ jsx(
            "a",
            {
              href: "https://teselagen.github.io/tg-oss/ui/",
              style: { fontSize: 16 },
              rel: "noreferrer",
              target: "_blank",
              children: "tg-oss/ui demo page"
            }
          ),
          /* @__PURE__ */ jsx("br", {}),
          "Teselagen Open Vector Editor - OVE - (Vector/Plasmid Editor) Demo",
          /* @__PURE__ */ jsx(
            "a",
            {
              href: "https://teselagen.github.io/tg-oss/ove/",
              style: { fontSize: 16 },
              rel: "noreferrer",
              target: "_blank",
              children: "tg-oss/ove demo page"
            }
          ),
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx("br", {}),
          /* @__PURE__ */ jsx("br", {})
        ] })
      ]
    }
  );
};
